import {
    DashboardWidget,
    WidgetBody,
    WidgetDataPoint,
    WidgetFooter,
    WidgetHeader,
    WidgetSkeleton,
    WidgetType
} from "@flexinet/ui-components";
import {NavLink} from "react-router-dom";
import {Invoice} from "../../invoices/types";

interface InvoicesSummaryWidgetProps {
    totalCount: number;
    latestInvoice: Invoice | null;
    loading: boolean;
    customerId: string;
}

const formatDate = (dateStr?: string) => {
    if (!dateStr) return 'N/A';
    return new Date(dateStr).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
};

export const InvoicesSummaryWidget = ({totalCount, latestInvoice, loading, customerId}: InvoicesSummaryWidgetProps) => {

    if (loading) {
        return <WidgetSkeleton/>;
    }

    const dataPoints: WidgetDataPoint[] = [
        {
            value: totalCount,
            label: latestInvoice
                ? `Latest: ${formatDate(latestInvoice.created)}`
                : 'No invoices yet',
            color: totalCount > 0 ? 'blue' : 'gray',
        },
    ];

    const widget: WidgetType = {
        header: {
            title: 'Invoices',
        },
        body: {
            dataPoints,
            metrics: [],
        },
        footer: {
            actionItems: [
                {
                    label: 'View All Invoices',
                    component: {NavLink},
                    to: `/customers/${customerId}#tab=Invoices`,
                    visible: true,
                },
            ],
        },
    };

    return (
        <DashboardWidget
            header={<WidgetHeader {...widget.header}/>}
            body={<WidgetBody {...widget.body}/>}
            footer={<WidgetFooter {...widget.footer}/>}
        />
    );
};
